import { buildAutoPrompt } from './photoslopApi';

export const initialPhotoslopState = {
  pickingRoot: true,
  activeFolderKey: null,
  root: null,
  secondaries: [],
  promptText: '',
  promptDirty: false,
  styling: '',
  count: 1,
  aspect: '1:1',
  outputSlots: [],
  generating: false,
  generateError: null,
};

function autoPromptFor(s) {
  if (!s.root) return '';
  return buildAutoPrompt(
    s.root.path,
    s.secondaries.map((x) => x.path),
  );
}

export function photoslopReducer(state, action) {
  switch (action.type) {
    case 'ENTER_PICK_ROOT':
      return { ...state, pickingRoot: true, activeFolderKey: action.folderKey };
    case 'SET_ROOT':
      return {
        ...state,
        root: action.root,
        pickingRoot: false,
        promptText: state.promptDirty ? state.promptText : autoPromptFor({ ...state, root: action.root }),
        promptDirty: false,
      };
    case 'CLEAR_ROOT':
      return {
        ...state,
        root: null,
        secondaries: [],
        pickingRoot: true,
        promptText: '',
        promptDirty: false,
      };
    case 'SET_ACTIVE_FOLDER':
      return { ...state, activeFolderKey: action.folderKey };
    case 'TOGGLE_SECONDARY': {
      const exists = state.secondaries.some((s) => s.path === action.asset.path);
      const secondaries = exists
        ? state.secondaries.filter((s) => s.path !== action.asset.path)
        : [...state.secondaries, action.asset].slice(0, 15);
      const next = { ...state, secondaries };
      return {
        ...next,
        promptText: state.promptDirty ? state.promptText : autoPromptFor(next),
        promptDirty: false,
      };
    }
    case 'REMOVE_SECONDARY': {
      const secondaries = state.secondaries.filter((s) => s.path !== action.path);
      const next = { ...state, secondaries };
      return {
        ...next,
        promptText: state.promptDirty ? state.promptText : autoPromptFor(next),
        promptDirty: false,
      };
    }
    case 'REORDER_SECONDARIES': {
      const arr = [...state.secondaries];
      const [moved] = arr.splice(action.from, 1);
      arr.splice(action.to, 0, moved);
      const next = { ...state, secondaries: arr };
      return {
        ...next,
        promptText: state.promptDirty ? state.promptText : autoPromptFor(next),
        promptDirty: false,
      };
    }
    case 'SET_PROMPT':
      return { ...state, promptText: action.text, promptDirty: true };
    case 'REBUILD_PROMPT':
      return { ...state, promptText: autoPromptFor(state), promptDirty: false };
    case 'SET_STYLING':
      return { ...state, styling: action.styling };
    case 'SET_COUNT':
      return { ...state, count: action.count };
    case 'SET_ASPECT':
      return { ...state, aspect: action.aspect };
    case 'START_GENERATION':
      return {
        ...state,
        generating: true,
        generateError: null,
        outputSlots: action.jobIds.map((jobId) => ({
          jobId: jobId || null,
          status: jobId ? 'running' : 'failed',
          imagePath: undefined,
          error: jobId ? undefined : 'No job id',
        })),
      };
    case 'UPDATE_SLOT':
      return {
        ...state,
        outputSlots: state.outputSlots.map((slot, i) =>
          i === action.index ? { ...slot, ...action.patch } : slot,
        ),
      };
    case 'SET_GENERATING':
      return { ...state, generating: action.v };
    case 'SET_GENERATE_ERROR':
      return { ...state, generateError: action.msg, generating: false };
    case 'NEW_SESSION':
      return { ...initialPhotoslopState };
    default:
      return state;
  }
}
